import type { ReactNode } from 'react'
import styles from './OCRScopeJobDetailHeader.module.css'
import cx from 'classnames'

interface OCRScopeJobDetailHeaderFieldProps {
  children?: ReactNode
}

export function OCRScopeJobDetailHeaderField({
  children,
}: OCRScopeJobDetailHeaderFieldProps) {
  return <div className={styles.detailHeaderField}>{children}</div>
}

export function OCRScopeJobDetailHeaderFieldName({
  children,
}: OCRScopeJobDetailHeaderFieldProps) {
  return <span className={styles.detailHeaderFieldName}>{children}</span>
}

export function OCRScopeJobDetailHeaderFieldValue({
  children,
}: OCRScopeJobDetailHeaderFieldProps) {
  return <span className={styles.detailHeaderFieldValue}>{children}</span>
}

export function OCRScopeJobDetailHeaderFieldSeparator() {
  return <span className={styles.detailHeaderFieldSeparator}>|</span>
}

export interface OCRScopeJobDetailHeaderProps {
  title: string
  statusName: string
  isHealthy: boolean
  showConfidenceLevel: boolean
  confidenceLevel: string
  showTotal: boolean
  total: number
  createdByName: string
}

export function OCRScopeJobDetailHeader({
  title,
  statusName,
  isHealthy,
  showConfidenceLevel,
  confidenceLevel,
  showTotal,
  total,
  createdByName,
}: OCRScopeJobDetailHeaderProps) {
  return (
    <div className={styles.root}>
      <div className={styles.detailHeaderTitle}>{title}</div>
      <div className={styles.detailHeaderFieldContainer}>
        <OCRScopeJobDetailHeaderField>
          <OCRScopeJobDetailHeaderFieldName>
            Status
          </OCRScopeJobDetailHeaderFieldName>
          <span
            className={cx(
              styles.detailHeaderStatusField,
              isHealthy
                ? styles.detailHeaderStatusFieldGreen
                : styles.detailHeaderStatusFieldRed,
            )}
          />
          <OCRScopeJobDetailHeaderFieldValue>
            {statusName}
          </OCRScopeJobDetailHeaderFieldValue>
        </OCRScopeJobDetailHeaderField>

        {showConfidenceLevel && (
          <OCRScopeJobDetailHeaderField>
            <OCRScopeJobDetailHeaderFieldSeparator />
            <OCRScopeJobDetailHeaderFieldName>
              Confidence rating
            </OCRScopeJobDetailHeaderFieldName>
            <OCRScopeJobDetailHeaderFieldValue>
              {confidenceLevel}%
            </OCRScopeJobDetailHeaderFieldValue>
          </OCRScopeJobDetailHeaderField>
        )}

        {showTotal && (
          <OCRScopeJobDetailHeaderField>
            <OCRScopeJobDetailHeaderFieldSeparator />
            <OCRScopeJobDetailHeaderFieldName>
              Total
            </OCRScopeJobDetailHeaderFieldName>
            <OCRScopeJobDetailHeaderFieldValue>
              ${total}
            </OCRScopeJobDetailHeaderFieldValue>
          </OCRScopeJobDetailHeaderField>
        )}

        <OCRScopeJobDetailHeaderField>
          <OCRScopeJobDetailHeaderFieldSeparator />
          <OCRScopeJobDetailHeaderFieldName>
            Created by
          </OCRScopeJobDetailHeaderFieldName>
          <OCRScopeJobDetailHeaderFieldValue>
            {createdByName}
          </OCRScopeJobDetailHeaderFieldValue>
        </OCRScopeJobDetailHeaderField>
      </div>
    </div>
  )
}
